import { createDefaultWidgetPage, DEFAULT_WIDGET_PAGE_ID, getDB } from '../core';
import type { WidgetPage } from '@/types';

export async function addWidgetPage(page: WidgetPage): Promise<void> {
  const db = await getDB();
  await db.put('widgetPages', page);
}

export async function getAllWidgetPages(): Promise<WidgetPage[]> {
  const db = await getDB();
  return db.getAllFromIndex('widgetPages', 'by-order');
}

export async function getWidgetPage(id: string): Promise<WidgetPage | undefined> {
  const db = await getDB();
  return db.get('widgetPages', id);
}

export async function updateWidgetPage(page: WidgetPage): Promise<void> {
  const db = await getDB();
  await db.put('widgetPages', { ...page, updatedAt: Date.now() });
}

export async function deleteWidgetPage(id: string): Promise<void> {
  const db = await getDB();
  await db.delete('widgetPages', id);
}

export async function getOrCreateDefaultWidgetPage(): Promise<WidgetPage> {
  const db = await getDB();
  const existing = await db.get('widgetPages', DEFAULT_WIDGET_PAGE_ID);
  if (existing) return existing;

  const defaultPage = createDefaultWidgetPage();
  await db.put('widgetPages', defaultPage);
  return defaultPage;
}
